import type { Signal } from '@app/types/sdk';

export const SSH_CONNECTIONS_TOTAL_SIGNAL_KEY = 'cli_tcp_established_ssh_connections_total';
export const SSH_CONNECTION_LIMIT_SIGNAL_KEY = 'cli_tcp_ssh_connection_limit';
export const SSH_CONNECTIONS_BY_VRF_SIGNAL_KEY = 'cli_tcp_established_ssh_connections';
export const SSH_PER_HOST_CONNECTION_LIMIT_SIGNAL_KEY = 'cli_tcp_ssh_per_host_connection_limit';

export interface SSHSessionSignalSummary {
  deviceId: string;
  total?: Signal;
  globalLimit?: Signal;
  perSourceIPLimit?: Signal;
  vrfs: Signal[];
  observedAt?: string;
}

export const groupSSHSessionSignals = (items: Signal[]): SSHSessionSignalSummary[] => {
  const byDevice = new Map<string, Omit<SSHSessionSignalSummary, 'deviceId'>>();
  for (const item of items) {
    const deviceId = item.deviceId?.trim() ?? '';
    if (!deviceId) {
      continue;
    }
    const device = byDevice.get(deviceId) ?? { vrfs: [] };
    switch (item.signalKey) {
      case SSH_CONNECTIONS_TOTAL_SIGNAL_KEY:
        device.total = item;
        break;
      case SSH_CONNECTION_LIMIT_SIGNAL_KEY:
        device.globalLimit = item;
        break;
      case SSH_PER_HOST_CONNECTION_LIMIT_SIGNAL_KEY:
        device.perSourceIPLimit = item;
        break;
      case SSH_CONNECTIONS_BY_VRF_SIGNAL_KEY:
        device.vrfs.push(item);
        break;
      default:
        continue;
    }
    byDevice.set(deviceId, device);
  }

  return Array.from(byDevice.entries()).map(([deviceId, device]) => {
    const observedAt = [device.total, device.globalLimit, device.perSourceIPLimit, ...device.vrfs]
      .map((item) => item?.observedAt)
      .filter((value): value is string => Boolean(value))
      .sort()
      .at(-1);
    return {
      deviceId,
      ...device,
      vrfs: device.vrfs.slice().sort((left, right) => (left.instance ?? '').localeCompare(right.instance ?? '')),
      observedAt
    };
  });
};
